import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { Topography } from '../Topography/Topography';

import styles from './DependentItem.module.scss';

type DependentItemProps = {
  to?: string;
  name: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const DependentItem: React.FC<DependentItemProps> = ({ to = '', name, className, onClick }) => (
  <div className={clsx(styles.root, className)}>
    <Link to={to} id={name} className={styles.body} onClick={onClick}>
      <Topography.H4>{name}</Topography.H4>
    </Link>
  </div>
);
